import { useContext } from 'react';
import { GoogleReCaptchaContext } from 'contexts/google-recapcha-provider/google-recapcha-provider';

export const useGoogleReCaptcha = () => {
  const context = useContext(GoogleReCaptchaContext);
  if (!context) {
    throw new Error(
      'useGoogleReCaptcha must be used within a GoogleReCaptchaProvider',
    );
  }
  return context;
};
